import React, { Suspense, lazy } from "react";
import { Spinner } from "@radix-ui/themes";

//Lazy wrappers for the two heaviest modals (plan 5.1). Every sheet renders
//these conditionally, so the wrapper keeps the Suspense boundary next to the
//lazy component and import sites stay one-line swaps.
const LazyAddEditInventory = lazy(() => import("./AddEditInventory"));
const LazyAddEditCommitted = lazy(() => import("./AddEditCommitted"));

//Dim the page like the modal overlay would while the chunk downloads.
const modalFallback = (
    <div style={{ position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.3)", zIndex: 50 }}>
        <Spinner size="3" />
    </div>
);

export function AddEditInventory(props) {
    return (
        <Suspense fallback={modalFallback}>
            <LazyAddEditInventory {...props} />
        </Suspense>
    );
}

export function AddEditCommitted(props) {
    return (
        <Suspense fallback={modalFallback}>
            <LazyAddEditCommitted {...props} />
        </Suspense>
    );
}
